import React from 'react'
interface SeeMoreProps {
  onClick?: () => void
}
const SeeMore = ({ onClick }: SeeMoreProps) => {
  return (
    <button
      onClick={onClick}
      className='text-xs sm:text-sm md:text-base font-medium text-[#001A3D] text-right leading-[24px] tracking-wide cursor-pointer bg-transparent border-none outline-none'
    >
      See More
    </button>
  )
}
export default SeeMore
